import classNames from "classnames";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

function GdModalConfirm({
  content,
  hideOkButton = false,
  hideCancelButton = false,
  cancelButtonProps = null,
  okButtonProps = null,
  className,
  ...props
}) {
  return (
    <HBModal
      className={classNames([styles.modal, className])}
      width={400}
      okButtonProps={{
        className: classNames([
          styles.okButton,
          hideOkButton ? styles.hidden : null,
        ]),
        type: "default",
        ...okButtonProps,
      }}
      cancelButtonProps={{
        className: classNames([
          styles.cancelButton,
          hideCancelButton ? styles.hidden : null,
        ]),
        ...cancelButtonProps,
      }}
      {...props}
    >
      {content}
    </HBModal>
  );
}

export default ModalWrap(GdModalConfirm, {
  unique: true,
});
